import {
  ref, watch, reactive, toRef,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function useVoucherCardList(ctx) {
  const columns = [
    {
      key: 'serial_number',
      label: 'Serial Number',
    },
    {
      key: 'external_id',
      label: 'Driver ID',
    },
    {
      key: 'charged_at',
      label: 'Charged Date',
      formatter: val => formatDate(val),
    },
    {
      key: 'active',
    },
    {
      key: 'charged',
    },
    {
      key: 'amount',
    },
    {
      key: 'expiry_date',
      label: 'Expiry Date',
    },
    {
      key: 'actions',
    },
  ]
  const queryParams = reactive({
    size: 10,
    page: 1,
    serial_number: null,
  })
  const cards = ref([])
  const cardsLoading = ref(false)
  const totalCards = ref(0)
  const fetchCards = async () => {
    try {
      cardsLoading.value = true
      const res = await ctx.root.$store.dispatch('voucherCards/fetchCards', queryParams)
      cards.value = res.voucher_cards
      totalCards.value = res.total
    } finally {
      cardsLoading.value = false
    }
  }

  fetchCards()

  watch([toRef(queryParams, 'page'), toRef(queryParams, 'size')], () => {
    fetchCards()
  })

  const editCardInfo = ref(null)
  const displayModal = (mode, card) => {
    if (mode === 'edit') {
      editCardInfo.value = card
    } else {
      editCardInfo.value = null
    }
    ctx.root.$bvModal.show('voucher-generate-cards')
  }

  return {
    columns,
    cards,
    cardsLoading,
    fetchCards,
    totalCards,
    queryParams,
    displayModal,
    editCardInfo,
  }
}
